import _ from 'lodash';
import { format, isValid, parse, setISODay } from 'date-fns';
import Schema from '../common/schema';

const EMPTY_STRING = '';

export function isStringEmpty(str) {
  if (str === 0) {
    return false;
  }
  return (str || EMPTY_STRING).length === 0;
}

export function jsonErrorsToObject(errorsArray) {
  return _.transform(
    errorsArray,
    (errorsObj, error) => {
      const instancePath =
        error.keyword === 'required'
          ? `${error.instancePath}/${error.params.missingProperty}`
          : error.instancePath;

      const path =
        instancePath
          .replace('/', '')
          .replace(/\/([0-9]+)/, '[$1]')
          .replace(/\//g, '.')
          .replace(/^\./g, '') + '.self';

      if (!_.get(errorsObj, path)) {
        _.set(errorsObj, path, error.message);
      }
    },
    {},
  );
}

export function validateSchema(data, schemaId) {
  let schema = Schema.getSchema(schemaId);
  let valid = schema(data);
  return valid ? null : jsonErrorsToObject(schema.errors);
}

export function dayOrdinalToString(dayOrdinal) {
  return format(setISODay(new Date(), dayOrdinal), 'EEEE');
}

export function parseTime(time) {
  const timeString = time && time.trim();
  if (!timeString) return false;

  for (const timeFormat of ['HH:mm', 'hh:mm a']) {
    const parsed = parse(timeString, timeFormat, new Date());
    if (isValid(parsed)) return parsed;
  }

  return false;
}

export function hoursTo24(time) {
  let parsed = parseTime(time);
  return parsed && format(parsed, 'HH:mm');
}

export function hoursTo12(time) {
  let parsed = parseTime(time);
  return parsed && format(parsed, 'hh:mm a');
}

export function parseNumber(str) {
  let number = str && str.length > 0 && _.toNumber(str);
  return isNaN(number) ? null : number;
}

export function getFinalValueForValidation(actualValue) {
  let parsedValueInNumber = parseNumber(actualValue);
  let finalValue;

  // Ensure finalValue has some value to satisfy the validation condition for the field not being empty
  // Use case:
  // If we use the parsed number value for 'finalValue', for non-number value (say 'abc')
  // it would be null, which means, though the given field has some value it would be considered
  // as empty which means 'Register' button will be disabled in registration step 3.
  // On the other hand if the parsed value is a non-number, pass the actual value as 'finalValue' without parsing
  // it as number so that the given field will not be considered empty but it will get caught in the schema validation.
  if (parsedValueInNumber) {
    finalValue = parsedValueInNumber;
  } else {
    finalValue = actualValue;
  }

  return finalValue;
}
